// extracted by mini-css-extract-plugin
module.exports = {"nav":"nav_nav__3MmnC","list":"nav_list__1Sohv"};